import { render, staticRenderFns } from "./TableFields.vue?vue&type=template&id=4d426d63&"
import script from "./TableFields.vue?vue&type=script&lang=js&"
export * from "./TableFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports